


















































import { Mixins, Component } from 'vue-property-decorator';
import Table from '@/components/Table/Index.vue';
import { getModule } from 'vuex-module-decorators';
import GameModule from '@/store/modules/Game';
import ErrorHandleMixin from '@/mixins/ErrorHandle.vue';

@Component({
  components: {
    Table,
  },
})
export default class VersionControl extends Mixins(ErrorHandleMixin) {
  TableHead = [
    [
      {
        text: 'No',
      },
      {
        text: 'Env',
        attr: {
          class: 'text-left',
        },
      },
      {
        text: 'Version',
        attr: {
          class: 'text-left',
        },
      },
      {
        text: 'Type',
        attr: {
          class: 'text-left',
        },
      },
      {
        text: 'Manage version',
        attr: {
          class: 'text-left',
        },
      },
    ],
  ];

  GameInstance = getModule(GameModule, this.$store);

  data = [];

  version = false;

  url = '';

  name = '';

  type = '';

  created() {
    this.fetchGame();
  }

  async fetchGame() {
    this.GeneralInstance.toggleLoading(true);
    const res = await this.GameInstance.FetchVersionControl();
    if (res.code) {
      this.checkError(res);
    } else {
      this.data = res;
    }
    this.GeneralInstance.toggleLoading(false);
  }

  editVersion(val) {
    this.type = val.type;
    this.name = val.name ? val.name : '';
    this.url = val.url;
    this.version = true;
  }

  async handleVersion(url) {
    this.GeneralInstance.toggleLoading(true);
    const res = await this.GameInstance.EditVersion(
      { name: this.name, url, type: this.type },
    );
    if (res.code === 0) {
      this.checkError(res);
    } else {
      this.GeneralInstance.ShowAlert({
        isAlert: true,
        alertMsg: res.message,
        alertColor: res.code === 0 ? 'success' : 'danger',
      });
    }
    this.version = false;
    this.fetchGame();
    this.GeneralInstance.toggleLoading(false);
  }

  handleChange() {
    this.fetchGame();
  }
}
